import type { recurringFeeType_enum } from '@vrplatform/graphql';
import type { FeeOverviewRoute } from './_types';

const MAPPING: Record<FeeOverviewRoute, recurringFeeType_enum> = {
  'booking-channel-fees': 'bookingChannelFee',
  'merchant-fees': 'merchantFee',
  other: 'additionalFee',
  commissions: 'managementFee',
  'cleaning-fees': 'cleaningFee',
};

export const getRecurringFeeEnumFromFeeTypeRoute = (
  feeType: FeeOverviewRoute
) => {
  return MAPPING[feeType];
};

export const getFeeTypeRouteFromRecurringFeeEnum = (
  recurringFeeEnum: recurringFeeType_enum
) => {
  return Object.keys(MAPPING).find(
    (key) => MAPPING[key as FeeOverviewRoute] === recurringFeeEnum
  )! as FeeOverviewRoute;
};

export const FEE_TITLES: Record<FeeOverviewRoute, string> = {
  'booking-channel-fees': 'Booking Channel Fee',
  'cleaning-fees': 'Cleaning Fee',
  'merchant-fees': 'Merchant Fee',
  commissions: 'Management Commission',
  other: 'Other Fee',
};
export const getFeeTitleFromFeeTypeRoute = (feeType: FeeOverviewRoute) => {
  return FEE_TITLES[feeType];
};
